import {DataModificationsHeader} from 'audit/DataModifications';
import {
  PlateCreationStructuredTable,
  PlateCreationTableMetadata,
  PlateCreationTableRowMetadata,
} from 'notebook/integrations/samples/PlateCreationStructuredTableAdapter';
import {ACTION_CREATE_ROW_PLATES} from 'notebook/store/VersioningConstants';
import {doPerformCreatePlates} from 'notebook/structured-tables/action-functions/createPlatesActionFunction';
import makeSubmitRowActionFunction, {
  getRowAwareLoadingMessage,
} from 'notebook/structured-tables/action-functions/makeSubmitRowActionFunction';
import {
  ActionResultType,
  performServerSideTableWriteActionWithAudits,
} from 'notebook/structured-tables/action-functions/PerformActionFunctions';
import invokeStructuredTableMappings from 'notebook/structured-tables/structured-table-mappings/invokeStructuredTableMappings';
import {AxisContextMenuActionFunctionParameters} from 'notebook/structured-tables/StructuredTableConstants';

export const SUBMIT_PLATE_CREATION_ROW_ACTION_FUNCTION_CONFIG = {
  allowOutsideOfEntry: false,
  onSelectForSubmit: async (
    actionFunctionParams: AxisContextMenuActionFunctionParameters<
      PlateCreationTableMetadata,
      PlateCreationTableRowMetadata
    >
  ): Promise<void> => {
    const entryId = actionFunctionParams.entryOrTemplateId!;
    const plateCreationStructuredTable: PlateCreationStructuredTable = actionFunctionParams.structuredTable;
    const selection = {
      start: actionFunctionParams.selectionRange!.minIndex,
      end: actionFunctionParams.selectionRange!.maxIndex + 1,
    };
    await performServerSideTableWriteActionWithAudits({
      entryId,
      loadingScreenMessage: getRowAwareLoadingMessage(
        selection,
        'Updating Plates For Rows',
        'Updating Plate For Row'
      ),
      autoSaverAction: ACTION_CREATE_ROW_PLATES,
      doPerformAction: (updateStatus?: (msg: string) => void, dataModsHeader?: DataModificationsHeader) =>
        doPerformCreatePlates(
          entryId,
          plateCreationStructuredTable,
          actionFunctionParams.computedTable,
          actionFunctionParams.actionFunctionContext,
          selection,
          updateStatus,
          dataModsHeader
        ),
      doPostRefresh: (actionResult) => {
        invokeStructuredTableMappings(
          entryId,
          plateCreationStructuredTable,
          actionResult.resultType === ActionResultType.PARTIAL_SUCCESS
            ? actionResult.submittedRange
            : selection
        );
        return Promise.resolve();
      },
      analyticsActionForPerfTracking: 'submit_plate_creation_structured_table_rows',
      structuredTables: [actionFunctionParams.structuredTable],
      structuredTableAdapters: [actionFunctionParams.structuredTableAdapter],
      computedTables: [actionFunctionParams.computedTable],
      tables: actionFunctionParams.table ? [actionFunctionParams.table] : [],
      selection,
    });
  },
};

export default makeSubmitRowActionFunction<PlateCreationTableMetadata, PlateCreationTableRowMetadata>(
  SUBMIT_PLATE_CREATION_ROW_ACTION_FUNCTION_CONFIG
);
